export function labelsReducer(state = "" ,{
    type,
    payload
}){
    
    switch(type){
        case "NEW_LABEL":            
        case "UPDATE_LABEL":
            let list = Object.assign({}, state);
            list[payload.label_id] = payload
        
            return list
            
        case "GET_LABELS":

            return payload
            
        default:
            return state;
    }
    
}